import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function LegalNoticePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Aviso Legal</h1>
        
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Datos identificativos</h2>
            <p className="text-gray-700 mb-4">
              En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos:
            </p>
            <ul className="list-none text-gray-700 space-y-2">
              <li><strong>Denominación social:</strong> ASISTEC</li>
              <li><strong>Email de contacto:</strong> correodeasistecsl@gmail.com</li>
              <li><strong>Teléfono:</strong> 628 752 701</li>
              <li><strong>WhatsApp:</strong> 628 752 701</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Objeto</h2>
            <p className="text-gray-700">
              El presente aviso legal regula el uso y utilización del sitio web, del que es titular ASISTEC. La navegación por el sitio web atribuye la condición de usuario del mismo e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Condiciones de uso</h2>
            <p className="text-gray-700 mb-4">
              El usuario se compromete a utilizar el sitio web, sus servicios y contenidos de conformidad con la legislación vigente, el presente Aviso Legal, y cualquier otro aviso o instrucciones puestas en su conocimiento.
            </p>
            <p className="text-gray-700 mb-4">
              El usuario se obliga a no utilizar el sitio web o los servicios que se presten a través del mismo con fines o efectos ilícitos o contrarios al contenido del presente Aviso Legal, lesivos de los intereses o derechos de terceros, o que de cualquier forma pueda dañar, inutilizar o deteriorar el sitio web o sus servicios.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Propiedad intelectual e industrial</h2>
            <p className="text-gray-700 mb-4">
              Todos los contenidos del sitio web, incluyendo sin carácter limitativo, textos, fotografías, gráficos, imágenes, iconos, tecnología, software, links y demás contenidos audiovisuales o sonoros, así como su diseño gráfico y códigos fuente, son propiedad intelectual de ASISTEC o de terceros, sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación reconocidos por la normativa vigente en materia de propiedad intelectual sobre los mismos.
            </p>
            <p className="text-gray-700">
              Queda prohibida la reproducción, distribución, comunicación pública y transformación de los contenidos del sitio web sin la autorización expresa de ASISTEC.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Responsabilidad</h2>
            <p className="text-gray-700 mb-4">
              ASISTEC no se hace responsable de:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>La continuidad y disponibilidad de los contenidos</li>
              <li>La ausencia de errores en dichos contenidos</li>
              <li>La ausencia de virus y/o demás componentes dañinos</li>
              <li>Los daños o perjuicios que cause cualquier persona que vulnere las condiciones, normas e instrucciones que ASISTEC establece en el sitio web</li>
              <li>Los contenidos de las páginas web de terceros a las que se pueda acceder mediante enlaces</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Enlaces</h2>
            <p className="text-gray-700">
              El sitio web puede contener enlaces a otros sitios web. ASISTEC no asume ninguna responsabilidad por el contenido, informaciones o servicios que pudieran aparecer en dichos sitios, que tendrán exclusivamente carácter informativo y que en ningún caso implican relación alguna entre ASISTEC y las personas o entidades titulares de tales contenidos o titulares de los sitios donde se encuentren.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Protección de datos</h2>
            <p className="text-gray-700">
              Para más información sobre el tratamiento de sus datos personales, consulte nuestra Política de Privacidad.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Modificaciones</h2>
            <p className="text-gray-700">
              ASISTEC se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su sitio web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Legislación aplicable y jurisdicción</h2>
            <p className="text-gray-700">
              Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia que pudiera surgir en relación con el sitio web o las actividades en él desarrolladas, serán competentes los Juzgados y Tribunales del domicilio del usuario.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contacto</h2>
            <p className="text-gray-700 mb-4">
              Para cualquier consulta relacionada con este aviso legal, puede contactarnos:
            </p>
            <ul className="list-none text-gray-700 space-y-2">
              <li><strong>Email:</strong> correodeasistecsl@gmail.com</li>
              <li><strong>Teléfono:</strong> 628 752 701</li>
              <li><strong>WhatsApp:</strong> 628 752 701</li>
            </ul>
          </section>

          <p className="text-gray-600 text-sm mt-12">
            Última actualización: Enero 2025
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}
